// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1RP03","dragIcon":"SortableItem_dragIcon__GGava","disabled":"SortableItem_disabled__e2ZCi"};